import { makeStyles } from '@material-ui/styles';

const useStyles = {
  menuContainer: {
    height: '0'
  },
  menuButton: {
    float: 'right',
    padding: '.4rem!important'
  }
};

export default makeStyles(useStyles);